export default function translateLuggageCount(
  { luggage20InchCount, luggage25InchCount, luggage27InchCount, luggage29InchCount },
  t,
) {
  const textArr = [];

  if (luggage20InchCount) {
    textArr.push(t('luggageCountWithUnitAndSize', { size: 20, count: luggage20InchCount }));
  }

  if (luggage25InchCount) {
    textArr.push(t('luggageCountWithUnitAndSize', { size: 25, count: luggage25InchCount }));
  }

  if (luggage27InchCount) {
    textArr.push(t('luggageCountWithUnitAndSize', { size: 27, count: luggage27InchCount }));
  }

  if (luggage29InchCount) {
    textArr.push(t('luggageCountWithUnitAndSize', { size: 29, count: luggage29InchCount }));
  }

  // FIXME: 這個沒翻到呀
  return textArr.join('、');
}
